module.exports = __webpack_public_path__ + "static/media/doc.96e548a9.svg";